import MTable from "../../components/mtable";
import { MatchingState, ParticipantType } from "../../utils/enums";
import { useEffect, useState } from "react";
import { api } from "../../env";
import { useDebounce } from "../../hooks/useDebounce";

export function ManualMatchingPanel({programId, program, exploreTrack}) {

    const mapper = {columns: [
        {
            label: "Name",
            value: (item) => `${item.user.firstName} ${item.user.lastName}`
        },
        {
            label: "Email",
            value: (item) => item.user.email
        },
        {
            label: "Role",
            value: (item) => item.type
        }
    ]}

    const [params, setParams] = useState({'status': MatchingState.WAITING})
    const [searchInput, setSearchInput] = useState("")
    const debouncedSearch = useDebounce(searchInput, 250)
    const [selection, setSelection] = useState({mentor: undefined, mentee: undefined})
    const [selectedTrack, setSelectedTrack] = useState(undefined)
    const onSetType = (val) => {
        setParams(prev => {
            if (val === "") {
                const {type, ...rest} = prev
                return rest
            }
            return {
                ...prev,
                type: val ?? ''
            }
        })
    }
    useEffect(() => {
        setParams(prev => {
            if (debouncedSearch === "") {
                const {search, ...rest} = prev
                return rest
            }
            return {
                ...prev,
                search: debouncedSearch ?? ''
            }
        })
    }, [debouncedSearch])

    const handleParticipantSelection = (selection) => {
        let mentors = selection.filter(it => it.type === ParticipantType.MENTOR)
        let mentees = selection.filter(it => it.type === ParticipantType.MENTEE)
        setSelection({mentor: mentors.length === 1 ? mentors[0] : mentors[1], mentee: mentees.length === 1 ? mentees[0] : mentees[1]})
    }

    const makeMatch = () => {
        api.post(`programs/${programId}/manual-matches`, {mentorEnrollmentId: selection.mentor.id, menteeEnrollmentId: selection.mentee.id, trackId: selectedTrack})
            .then(_ => {
                window.location.reload()
            })
            .catch(err => {
                console.log(err)
            })
    }

    return(<>
        <p className="card-body primary v-spacer-xs">1. Select Mentor & Mentee that you want to match together</p>
        <div className="flex gap-xs center space-between wrap vi-spacer-m v-spacer-m regular-border">
            <div className="input-wrapper">
                <span className="material-symbols-outlined icon input-icon">search</span>
                <input placeholder={'Search'} value={searchInput} className="w-100" onChange={(e) => setSearchInput(e.target.value)}/>
            </div>
            <div className="flex center gap-xs h-spacer-xs">
                <button className={params.type === ParticipantType.MENTOR ? 'solid' : 'elevated'} onClick={() => onSetType(ParticipantType.MENTOR)}>Mentor</button>
                <button className={params.type === ParticipantType.MENTEE ? 'solid' : 'elevated'} onClick={() => onSetType(ParticipantType.MENTEE)}>Mentee</button>
                <button className={params.type === undefined ? 'solid' : 'elevated'} onClick={() => onSetType("")}>Both</button>
            </div>
        </div>
        <MTable path={`programs/${programId}/participants`} queryParams={params} mapper={mapper} autoHideNavigation={true} selectable={{onChange: handleParticipantSelection, multiple: true, externallyManagedSelected: [selection.mentor, selection.mentee]}}/>
        <div className="vi-spacer-l v-spacer-xxl">
            <div className="dashed-border padding-m two-columns" style={{gridTemplateColumns: '1fr 100px 1fr'}}>
                <DisplayUser user={selection.mentor?.user} preferredTracks={selection.mentor?.chosenTracks} type={ParticipantType.MENTOR}/>
                <div className="flex justify-center center columns">
                    <span className="material-symbols-outlined primary scale-xxl">join_inner</span>
                </div>
                <DisplayUser user={selection.mentee?.user} preferredTracks={selection.mentee?.chosenTracks} type={ParticipantType.MENTEE}/>
            </div>
        </div>
        <SelectTrack programs={program?.tracks ?? []} exploreTrack={exploreTrack} trackSelected={(selection) => setSelectedTrack(selection?.[0]?.id)}/>
        <div className="flex center justify-center vi-spacer-xxl">
            <button className={`solid large ${selectedTrack && selection?.mentor && selection?.mentee ? '' : 'disabled'}`} disabled={!(selectedTrack && selection?.mentor && selection?.mentee)} style={{width: 'clamp(180px, 80%, 250px)'}} onClick={makeMatch}>Make a Match</button>
        </div>
    </>)
}

function SelectTrack({programs, exploreTrack, trackSelected}) {

    const mapper = {columns: [
        {
            label: "Name",
            value: (item) => item.displayName
        },
        {
            label: "Description",
            value: (item) => item.description
        },
        {
            label: "",
            actions: [
                {
                    label: "Explore Track",
                    onClick: (item) => exploreTrack(item.id)
                }
            ]
        }
    ]}

    return(<>
        <p className="card-body primary v-spacer-xs">2. Select the track for this match</p>
        <MTable rawData={programs} mapper={mapper} showHeader={false} selectable={{onChange: trackSelected, multiple: false}}/>
    </>)
}

function DisplayUser({user, preferredTracks, type}) {
    return(
        <div className="flex center columns padding-l">
            {user && <>
                <p className="card-title showing">{user.firstName} {user.lastName}</p>
                <p className="card-body neutral showing">{user.email}</p>
                <p className="card-label neutral vi-spacer-m showing">&lt;{type.toUpperCase()}&gt;</p>
                {preferredTracks && <div className="flex center wrap gap-xs vi-spacer-m showing">
                    <p className="medium primary card-label">Preferred Track(s): </p>
                    {preferredTracks.map(track => <p key={track?.trackId} className="chip primary-light-chip transparent card-label medium">{track.trackName}</p>)}
                </div>}
                {!preferredTracks && <p className="medium neutral card-body showing" style={{marginTop: 'calc(var(--s) + var(--xs))'}}>No Preferred Tracks</p>}
            </>}
            {!user && <>
                <span className="material-symbols-outlined neutral scale-xl neutral v-spacer-m">{type === ParticipantType.MENTOR ? 'supervisor_account' : 'person'}</span>
                <p className="card-label neutral">No {type} selected</p>
            </>}
        </div>
    )
}